import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=87b75100"
import script from "./TextInput.vue?vue&type=script&lang=js"
export * from "./TextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports